import React, { useEffect, useState } from "react";
import { Tab, Tabs } from 'react-bootstrap';  
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import IncomingAdminInvoices from "./incomingAdminInvoices";
import OutgoingAdminInvoices from "./outgoingAdminInvoices";
import "./hm-theme.css";

function AdminInvoices() {
  const [activeTab, setActiveTab] = useState('incomingInvoices');

  useEffect(() => {}, []);

  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">receipt</i>
                Admin Invoices
              </h2>
              <p className="hm-page-subtitle">
                Manage incoming and outgoing invoice statements, filters, and payment transaction history.
              </p>
            </div>
          </div>

          {/* Main Card with Modernized Tabs */}
          <div className="hm-card">
            <div className="hm-card-header pb-0 border-bottom-0">
              <div className="hm-tabs w-100">
                <Tabs
                  id="invoices-tabs"
                  activeKey={activeTab}
                  onSelect={(tab) => setActiveTab(tab)}
                  className="border-bottom-0"
                >
                  <Tab eventKey="incomingInvoices" title="Incoming Invoices">
                    {activeTab === 'incomingInvoices' && <IncomingAdminInvoices />}
                  </Tab>
                  <Tab eventKey="outgoingInvoices" title="Outgoing Invoices">
                    {activeTab === 'outgoingInvoices' && <OutgoingAdminInvoices />}
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminInvoices;